import { render } from "./TipoTicketComponent.vue?vue&type=template&id=ec2b0c52"
import script from "./TipoTicketComponent.vue?vue&type=script&lang=js"
export * from "./TipoTicketComponent.vue?vue&type=script&lang=js"

import "./TipoTicketComponent.vue?vue&type=style&index=0&id=ec2b0c52&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__